export default {
  siteTitle: 'AllChinaBuy Spreadsheet — Produkter, Sælgere & Smarte Købsguides',
  siteDescription: 'Udforsk AllChinaBuy spreadsheet-ressourcer, produktfund, sælgerguides, QC-information, forsendelsesomkostninger, anmeldelser og praktiske Kina-shopping-guides — alt organiseret på ét sted.',
  siteKeywords: 'AllChinaBuy, AllChinaBuy spreadsheet, AllChinaBuy anmeldelse, Kina shopping, spreadsheet guide',

  navHome: 'Hjem',
  navShoppingGuide: 'Købsguide',
  navCategories: 'Kategorier',
  navSpreadsheet: 'Spreadsheet',
  navProducts: 'Produkter',
  navSellers: 'Sælgere',
  navGuides: 'Guides',
  navReviews: 'Anmeldelser',
  navShipping: 'Forsendelse',
  navQC: 'QC',
  navCoupons: 'Kuponer',
  navAbout: 'Om os',
  navContact: 'Kontakt',

  heroH1: 'AllChinaBuy Spreadsheet — Find Produkter, Sælgere & Købsguides',
  heroSub: 'Udforsk AllChinaBuy spreadsheet-ressourcer, produktfund, sælgerguides, QC-information, forsendelsesomkostninger, anmeldelser og praktiske Kina-shopping-guides.',
  ctaExplore: 'Udforsk AllChinaBuy Spreadsheet',
  ctaBuyNow: 'Køb Nu',
  ctaReview: 'Læs Fuld Anmeldelse',
  ctaVisit: 'Besøg Hovedwebside',
  ctaMain: 'AllChinaBuy Spreadsheet',

  categoryTitle: 'Gennemse Kategorier',
  categorySubtitle: 'Find præcis det, du har brug for, i vores kuraterede spreadsheet-samlinger',
  categories: [
    { name: 'Sko', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { name: 'Hættetrøjer/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
    { name: 'Jakker', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
    { name: 'Bukser/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
    { name: 'Hovedbeklædning', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
    { name: 'Sæt', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
    { name: 'Undertøj', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
    { name: 'Trøjer', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
    { name: 'Tilbehør', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
    { name: 'Tasker', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
    { name: 'Bælter', url: 'https://kaspreadsheet.com/category-922-Belts.html' },
    { name: 'Parfumer', url: 'https://kaspreadsheet.com/category-923-Perfumes.html' },
    { name: 'Andet', url: 'https://kaspreadsheet.com/category-924-Other+Stuff.html' },
  ],

  articleTitle: 'AllChinaBuy Spreadsheet Guides & Artikler',
  articleSubtitle: 'Dybdegående ressourcer til at hjælpe dig med at navigere AllChinaBuy som en professionel',
  readMore: 'Læs Mere',
  article1Title: 'AllChinaBuy Spreadsheet 2026: Komplet Guide for Smarte Købere',
  article1Desc: 'Opdag, hvordan du bruger AllChinaBuy spreadsheet til at finde de bedste produkter, betroede sælgere og spare penge på din Kina-shopping-rejse.',
  article1Meta: 'Opdateret august 2026 · 8 min. læsetid',
  backToHome: 'Tilbage til Hjem',
  relatedArticles: 'Relaterede Artikler',
  shareArticle: 'Del Denne Guide',

  footerDisclaimer: 'AllChinaBuySpreadsheet.best er en uafhængig informationsressource og er ikke tilknyttet eller godkendt af AllChinaBuy.',
  footerLinks: 'Hurtige Links',
  footerLegal: 'Juridisk & Sikkerhed',
  footerPrivacy: 'Privatlivspolitik',
  footerTerms: 'Brugsvilkår',
  footerEditorial: 'Redaktionel Politik',
  footerSafety: 'Sikkerhedsguide',
  footerCopyright: '© 2026 AllChinaBuySpreadsheet.best. Alle rettigheder forbeholdes.',
  footerLanguage: 'Sprog',

  articleIntro: 'Introduktion',
  articleTOC: 'Indholdsfortegnelse',
  articleConclusion: 'Konklusion',
  articleCTA: 'Klar til at shoppe smartere?',
  articleCTABtn: 'Udforsk AllChinaBuy Spreadsheet',
  articleInternalLink: 'Vend tilbage til vores AllChinaBuy Spreadsheet-hjemmeside for flere ressourcer og købsguides.',

  selectCategory: 'Vælg en Kategori',
  browseAll: 'Gennemse Alle Kategorier',

  trustIndependent: 'Uafhængig Ressource',
  trustVerified: 'Verificeret Information',
  trustUpdated: 'Regelmæssigt Opdateret',
  trustCommunity: 'Community-drevet',
};